import * as actionType from "./action";

export function configDefaultReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_CONFIG_DEFAULT_SUCCESS:
      return {
        ...state,
        response,
      };
    case actionType.GET_CONFIG_DEFAULT_ERROR:
      return {
        ...state,
        response,
      };
    default:
      return state;
  }
}

/* Configuration */
export function configsReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_CONFIGS_SUCCESS:
      return {
        ...state,
        response,
      };
    case actionType.GET_CONFIGS_ERROR:
      return {
        ...state,
        response,
      };
    default:
      return state;
  }
}

export function configReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_CONFIG_SUCCESS:
      return {
        ...state,
        response,
      };
    case actionType.GET_CONFIG_ERROR:
      return {
        ...state,
        response,
      };
    default:
      return state;
  }
}

export function configOpReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.ADD_CONFIG_KEY_SUCCESS:
      return state;
    case actionType.ADD_CONFIG_KEY_ERROR:
      return {
        ...state,
        response,
      };
    case actionType.MODIFY_CONFIG_KEY_SUCCESS:
      return state;
    case actionType.MODIFY_CONFIG_KEY_ERROR:
      return {
        ...state,
        response,
      };
    case actionType.DELETE_CONFIG_KEY_SUCCESS:
      return state;
    case actionType.DELETE_CONFIG_KEY_ERROR:
      return {
        ...state,
        response,
      };
    default:
      return state;
  }
}
